import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", this.props.name || "", error, info?.componentStack);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="rounded-xl border border-red-500/40 bg-red-500/10 text-red-200 p-4 text-sm" data-testid={`error-boundary-${this.props.name || "section"}`}>
        <p className="font-medium">{this.props.title || "Something went wrong in this section."}</p>
        <p className="text-red-200/80 mt-1">{this.props.message || "Your other details are safe. Try again, or refresh the page if it keeps happening."}</p>
        <button type="button" onClick={this.reset} className="mt-3 px-3 py-1.5 rounded-lg border border-red-400/50 hover:bg-red-500/20" data-testid={`error-boundary-${this.props.name || "section"}-retry`}>Try again</button>
      </div>
    );
  }
}

export default ErrorBoundary;
